import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const handleAuthResult = (data) => {
    if (data.token) localStorage.setItem("am_token", data.token);
    setUser(data.user || data);
  };

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    handleAuthResult(data);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    handleAuthResult(data);
    return data.user;
  };

  const demoLogin = async () => {
    const { data } = await api.post("/auth/demo");
    handleAuthResult(data);
    return data.user;
  };

  const guestLogin = async () => {
    let dev = localStorage.getItem("am_device");
    if (!dev) { dev = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()); localStorage.setItem("am_device", dev); }
    const { data } = await api.post("/auth/seeker", { device_id: dev });
    handleAuthResult(data);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("am_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, demoLogin, guestLogin, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
